import service from '@/utils/request'

export function roleList(param) {
	return service.request({
		method: 'post',
		url: '/app/role/roleList',
		data: param
	})
}

export function listRole(param) {
	return service.request({
		method: 'post',
		url: '/app/role/list',
		data: param
	})
}
/**
 * 根据角色ID 查询绑定的菜单权限 信息
 * @param {Object} param
 */
export function rolePermissionByRId(param) {
	return service.request({
		method: 'post',
		url: '/app/rolePermission/rolePermissionByRId',
		data: param
	})
}


/**
 * 根据角色ID 查询绑定的 部门 信息
 * @param {Object} param
 */
export function roleDeptByRId(param) {
	return service.request({
		method: 'post',
		url: '/app/roleDept/roleDeptByRId',
		data: param
	})
}
/**
 * 根据角色ID 绑定的 数据权限
 * @param {Object} param
 */
export function addDataScope(param) {
	return service.request({
		method: 'post',
		url: '/app/role/dataScope',
		data: param
	})
}

export function addRole(param) {
	return service.request({
		method: 'post',
		url: '/app/role/add',
		data: param
	})
}

export function editRole(param) {
	return service.request({
		method: 'post',
		url: '/app/role/edit',
		data: param
	})
}
export function delRole(param) {
	return service.request({
		method: 'post',
		url: '/app/role/del',
		data: param
	})
}

export function exportRole(param) {
	return service.request({
		method: 'post',
		url: '/app/role/export',
		data: param
	})
}
